<template>
  <div v-if="isVisible" class="modal-backdrop">
    <div class="modal-content">
      <h4 class="mb-3">{{ $t("competitions.register_title") }}</h4>

      <p>{{ $t("competitions.confirm_registration") }}</p>

      <div class="modal-buttons">
        <button @click="confirmRegistration" class="btn btn-success">
          {{ $t("competitions.btn_confirm") }}
        </button>
        <button @click="closeModal" class="btn btn-secondary">
          {{ $t("competitions.btn_cancel") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RegisterAthleteModal",
  props: {
    isVisible: Boolean,
    competitionId: Number
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    confirmRegistration() {
      this.$emit("registered",this.competitionId);
      this.closeModal();
    },

  }
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 400px;
  text-align: center;
}
.modal-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.btn {
  padding: 8px 16px;
}
</style>
